<template>
  <div class="main">
      <div class="main-box">
        <!-- 配置文件类型选择 -->
        <div class="type-box">
          <md-radio v-model="type" :value="'auth'">Auth</md-radio>
          <md-radio v-model="type" :value="'ust'">Ust</md-radio>
          <md-radio v-model="type" :value="'utd'">Utd</md-radio>
          <md-radio v-model="type" :value="'mng'">Mng</md-radio>
        </div>
        <!-- 配置文件配置信息 -->
        <div v-if="type === 'auth'">
          <common-form-item 
            v-for="item in form_auth" 
            v-model="auth.Form[item.keys]" 
            :error ="auth.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <div v-if="type === 'ust'">
          <common-form-item 
            v-for="item in form_ust" 
            v-model="ust.Form[item.keys]" 
            :error ="ust.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <div v-if="type === 'utd'">
          <common-form-item 
            v-for="item in form_utd" 
            v-model="utd.Form[item.keys]" 
            :error ="utd.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
        <div v-if="type === 'mng'">
          <common-form-item 
            v-for="item in form_mng" 
            v-model="mng.Form[item.keys]" 
            :error ="mng.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </div>
      <!-- 输出 -->
      <div v-if="type === 'auth'" class="main-box">
        <div v-for="(i,index) in auth_txt" :key="index">
          <span v-if="i !== ''" class="putout" :class="{'highlight': auth_highlight.some(j => i.includes(j))}">{{i}}</span>
          <p v-else class="putout">{{"\n"}}</p>
        </div>
      </div>
      <div v-if="type === 'ust'" class="main-box">
        <div v-for="(i,index) in ust_txt" :key="index">
          <div v-if="i === 'TransSrvIpaddr'">
            <span v-for="(utd_item, utd_index) in ust_utd_group" :key="utd_item" class="putout" :class="{'highlight': ust_highlight.some(j => i.includes(j))}">
              TransSrvIpaddr[{{utd_index}}]={{utd_item}}
            </span>
          </div>
          <span v-else-if="i !== ''" class="putout" :class="{'highlight': ust_highlight.some(j => i.includes(j))}">{{i}}</span>
          <p v-else class="putout">{{"\n"}}</p>
        </div>
      </div>
      <div v-if="type === 'utd'" class="main-box">
        <div v-for="(i,index) in utd_txt" :key="index">
          <span v-if="i !== ''" class="putout" :class="{'highlight': utd_highlight.some(j => i.includes(j))}">{{i}}</span>
          <p v-else class="putout">{{"\n"}}</p>
        </div>
      </div>
      <div v-if="type === 'mng'" class="main-box">
        <div v-for="(i,index) in mng_txt" :key="index">
          <span v-if="i !== ''" class="putout" :class="{'highlight': mng_highlight.some(j => i.includes(j))}">{{i}}</span>
          <p v-else class="putout">{{"\n"}}</p>
        </div>
      </div>
  </div>
</template>
<script>
import { FormClass, /*nDaysAgo, nMonthsAgo, timestampToString1000,formatJsonForNotes, */ } from "@/common/tools.js";
export default {
  components: {},
  data() {
    return {
      type: 'auth',
      auth: new FormClass({
        server_id: "",
        server_addr: "",
        server_flag: "",
        auth_ip: "",
        html_ip: "",
        monkey:"",
        db_ip: "127.0.0.1",
        db_port: "6306",
        db_name: "npcmon",
        db_user: "root",
        db_pw: "/+vOn0dI6X8m1w==",
      },{
        server_id   :"required",
        server_addr :"required",
        server_flag :"required",
        auth_ip     :"required",
        html_ip     :"required",
        monkey      :"required",
        db_ip       :"required",
        db_port     :"required",
        db_name     :"required",
        db_user     :"required",
        db_pw       :"required",
      }),
      ust: new FormClass({
        server_addr :"",
        server_id   :"",
        server_ip   :"",
        auth_ip     :"",
        web_ip      :"",
        all_area    :"",
        open_area   :"",
        utds        :"",
      },{
        server_addr :"required",
        server_id   :"required",
        server_ip   :"required",
        auth_ip     :"required",
        web_ip      :"required",
        all_area    :"required",
        open_area   :"required",
        utds        :"required",
      }),
      utd: new FormClass({
        server_id: "",
        server_ip: "",
        auth_ip  : "",
        web_ip   : "",
      },{
        server_id: "required",
        server_ip: "required",
        auth_ip  : "required",
        web_ip   : "required",
      }),
      mng: new FormClass({
        server_ip: "",
        web_ip: "",
        open_ust: 0,
        open_auth: 0,
        open_utd: 0,
        open_web: 0,
      },{
        server_ip: "required",
        web_ip: "required",
      }),
    }
  },
  watch:{
    'auth.Form':{
      deep:true,
      handler(){
        this.auth.Check();
      },
    },
    'ust.Form':{
      deep:true,
      handler(){
        this.ust.Check();
      },
    },
    'utd.Form':{
      deep:true,
      handler(){
        this.utd.Check();
      },
    },
    'mng.Form':{
      deep:true,
      handler(){
        this.mng.Check();
      },
    },
  },
  mounted(){
    this.auth.Check();
    this.ust.Check();
    this.utd.Check();
    this.mng.Check();
  },
  computed:{
    /* AUTH */
      form_auth(){
        return [
          {
            label   : "服务器ID[AuthServerId]",
            keys    : "server_id",
            type    : "input",
            placeholder: "2+[...]",
            check   : true,
          },{
            label   : "服务器地址[AuthServerAddr]",
            keys    : "server_addr",
            type    : "input",
            placeholder: "www.hztscloud.net",
            check   : true,
          },{
            label   : "服务器标识[AuthSrvFlag]",
            keys    : "server_flag",
            type    : "input",
            placeholder: "hztsauth",
            check   : true,
          },{
            label   : "AUTH地址(本地)",
            keys    : "auth_ip",
            type    : "input",
            placeholder: "UstSrvIpaddr/DemoStreamIpaddr/ThumbSrvIpaddr/AuthPublicAddr/AuthPrivateAddr",
            check   : true,
          },{
            label   : "WEB地址[UmeyeSrvIpaddr]",
            keys    : "html_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "密钥key[MonLicenseKey]",
            keys    : "monkey",
            type    : "input",
            placeholder: "ip mac地址 生成",
            check   : true,
          },{
            label   : "数据库IP 地址[DbIpAddr]",
            keys    : "db_ip",
            type    : "input",
            placeholder: "",
            check   : true,
            class   : "database",
          },{
            label   : "数据库端口[DbPort]",
            keys    : "db_port",
            type    : "input",
            placeholder: "",
            check   : true,
            class   : "database",
          },{
            label   : "数据库名称[DbName]",
            keys    : "db_name",
            type    : "input",
            placeholder: "",
            check   : true,
            class   : "database",
          },{
            label   : "数据库登录用户[DbUser]",
            keys    : "db_user",
            type    : "input",
            placeholder: "",
            check   : true,
            class   : "database",
          },{
            label   : "数据库登录密码[DbPwd]",
            keys    : "db_pw",
            type    : "input",
            placeholder: "",
            check   : true,
            class   : "database",

          }
        ]
      },
      auth_txt(){
        return `[NET]
          AuthServerId=2${this.auth.Form.server_id}
          AuthServerAddr=${this.auth.Form.server_addr}
          AuthSrvFlag=${this.auth.Form.server_flag}

          DispListenPort=8250
          ListenPort=8350
          HttpPort=8000
          LogPort=8310
          AuthUdpPort=8350
          ExtUdpPort1=8551
          ExtUdpPort2=8552
          UstSrvIpaddr=${this.auth.Form.auth_ip}
          UstSrvPort=8600

          DemoStreamIpaddr=${this.auth.Form.auth_ip}
          DemoStreamPort=7400

          ThumbSrvNum=1

          ThumbSrvIpaddr[0]=${this.auth.Form.auth_ip}
          ThumbSrvPort[0]=8080

          SysFlag=hzts
          UmeyeSrvIpaddr=${this.auth.Form.html_ip}
          UmeyeSrvPort=6201


          [SYS]
          AuthPublicAddr=${this.auth.Form.auth_ip}
          AuthPublicPort=8350
          AuthPrivateAddr=${this.auth.Form.auth_ip}
          AuthPrivatePort=8350
          AlarmRecordSaveTimeLen=7
          FetchDevSpaceTimeLen=6000
          FetchLicAuthTimeLen=7200
          TransConnParamRecoNum=20
          UserSearchTransOverTime=6

          MonLicenseKey=${this.auth.Form.monkey}

          [DB]
          DbType=1
          DbIpAddr=${this.auth.Form.db_ip}
          DbPort=${this.auth.Form.db_port}
          DbName=${this.auth.Form.db_name}
          DbUser=${this.auth.Form.db_user}
          DbPwd=${this.auth.Form.db_pw}
          DbCharSetMode=2

          [VENDOR]
          IfVendorUser=0
          VendorId=2080
          LibFileName=NpcDevSynCDSB.dll
          SrvIpaddr=192.168.1.120
          SrvPort=5150
          DevSynSpaceTime=10
          IfUseAllPop=0

          [CMN]
          MnEnable=1
          MnUserName=admin
          MnUserPwd=admin

          [TRACE]
          IfNeedTrans=0
          TraceConnMode=0
          IfShowAlarmInfo=0
          IfShowDevStateInfo=0
          IfShowStatInfo=0
          IfWriteDevState=0
          IfShowTraceInfo=0

          [LIC]
          LicVerNo=1712426582
          LicDataMaxSize=300

          [PUSH]
          IfCloseCertCheck=1
          IfCloseQueryArmParam=0
        `.replaceAll(" ","").split(/\n/)
      },
      auth_highlight(){
        return ["AuthServerId", "AuthServerAddr", "AuthSrvFlag", "UstSrvIpaddr", "DemoStreamIpaddr", "ThumbSrvIpaddr", "AuthPublicAddr", "AuthPrivateAddr", "MonLicenseKey", "DbIpAddr", "DbPort", "DbName", "DbUser", "DbPwd"]
      },
    /* UST */
      form_ust(){
        return [
          {
            label   : "服务器地址[UstServerAddr]",
            keys    : "server_addr",
            type    : "input",
            placeholder: "www.hztscloud.net",
            check   : true,
          },{
            label   : "服务器ID[ServerId]",
            keys    : "server_id",
            type    : "input",
            placeholder: "12+[...]/UST+[...]",
            check   : true,
          },{
            label   : "服务器IP[ServerPublicIpaddr]",
            keys    : "server_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "AUTH服务器 IP[DispSrvIpaddr]",
            keys    : "auth_ip",
            type    : "input",
            placeholder: "DispSrvIpaddr/AuthSrvIpaddr/AuthSrvGroupIpaddr",
            check   : true,
          },{
            label   : "WEB服务器 IP[UmeyeSrvIpaddr]",
            keys    : "web_ip",
            type    : "input",
            placeholder: "UmeyeSrvIpaddr/OpenIpaddr",
            check   : true,
          },{
            label   : "全区域[AllUstAreas]",
            keys    : "all_area",
            type    : "input",
            placeholder: "xx|yy",
            check   : true,
          },{
            label   : "开启区域[CurUstAreas]",
            keys    : "open_area",
            type    : "input",
            placeholder: "xx|yy",
            check   : true,
          },{
            label   : "Utd数组(用逗号隔开)[TransSrvIpaddr]",
            keys    : "utds",
            type    : "input",
            placeholder: "xx,yy",
            check   : true,
          }
        ]
      },
      // 1 -> 001 10 -> 010
      ust_id(){
        var id = this.ust.Form.server_id
        if(this.ust.Form.server_id.length < 2){
          id = "00" + id;
        } else if(this.ust.Form.server_id.length < 3){
          id = "0" + id;
        }
        return id
      },
      ust_close_area(){
        const useArae = this.ust.Form.open_area.split("|");
        return this.ust.Form.all_area.split("|").filter(i => !(useArae.includes(i))).join("|")
      },
      ust_utd_group(){
        return this.ust.Form.utds.split(",")
      },
      ust_txt(){
        return `[SYS]
          UstServerAddr=${this.ust.Form.server_addr}
          ServerId=12${this.ust_id}
          ServerName=UST${this.ust.Form.server_id}
          ServerGroupId=40
          ServerPublicIpaddr=${this.ust.Form.server_ip}
          ClientUpdateDevStateSpaceTime=60

          IfForceDevChangeUst=0
          IfCheckDevAreaOnTest=0
          IfCheckDevAreaOnReg=1
          IfCheckDevSameAreaAsSrvOnTest=1
          IfOlnyLocalDevReg=0
          IfOnlySameSysFlagOnTest=1
          IfSendIdReg=1

          MaxOnlineDevNum=0

          [OAREA]
          Enable=1
          QueryTime=120
          CtrlSrvList=1
          SrvListCount=5
          IfOnlyLocalArea=1

          [NET]
          UstListenPort=8300
          ExtUdpListenPort=8301
          UstHttpPort=8070

          MnListenPort=8720
          TraceTcpListenPort=8730

          AgentBeginUdpPort=0
          AgentEndUdpPort=0

          DispSrvIpaddr=${this.ust.Form.auth_ip}
          DispSrvPort=8250

          AuthSrvIpaddr=${this.ust.Form.auth_ip}
          AuthSrvPort=8350

          SysFlag=hzts
          UmeyeSrvIpaddr=${this.ust.Form.web_ip}
          UmeyeSrvPort=6201

          OpenIpaddr=${this.ust.Form.web_ip}
          OpenPort=6003

          AuthSrvGroupAddrMode=1
          AuthSrvGroupPort=8300

          AuthSrvGroupDomainName=

          AuthSrvGroupIpaddrNum=1

          AuthSrvGroupIpaddr[0]=${this.ust.Form.auth_ip}

          LogPort=8732

          [LIC]
          LicFileType=3
          LicVerNo=918130836

          GetLicAuthTime=3600

          [UST]
          UstIpNum=0
          UstIp[0]=

          AllUstAreas=${this.ust.Form.all_area}
          CurUstAreas=${this.ust.Form.open_area}
          OtherUstAreas=${this.ust_close_area}


          [TRANSNAT]
          TransmitSrvPort=8550
          TransmitSrvNum=${this.ust_utd_group.length}

          TransSrvIpaddr

          TransNetType[4]=1

          [BLACKMODE]
          BMSrvNum=5

          BMSrvIpaddr[0]=5.189.239.76
          BMSrvIpaddr[1]=51.75.131.61
          BMSrvIpaddr[2]=192.155.96.246
          BMSrvIpaddr[3]=45.125.195.42
          BMSrvIpaddr[4]=115.159.94.63

          [TRACE]
          IfShowTraceInfo=0
          TraceConnMode=0
          IfStepQuitReg=0
          StepQuitTime=300
          IfShowDevStateUpdateInfo=0
          IfShowTransMode=1
          IfShowTestLog=0

          [CMN]
          MnEnable=1
          MnUserName=admin
          MnUserPwd=admin

          [UA]
          Enable=1
          UAIpaddr=8.136.123.47
          UAPort=6204
        `.replaceAll(" ","").split(/\n/)
      },
      ust_highlight(){
        return ["UstServerAddr", "ServerId", "ServerName", "ServerPublicIpaddr", "DispSrvIpaddr", "AuthSrvIpaddr", "UmeyeSrvIpaddr", "OpenIpaddr", "AuthSrvGroupIpaddr", "AllUstAreas", "CurUstAreas", "OtherUstAreas", "TransmitSrvNum", "TransSrvIpaddr"]
      },
    /* UTD */
      form_utd(){
        return [
          {
            label   : "服务器ID[ServerId]",
            keys    : "server_id",
            type    : "input",
            placeholder: "14+[...]",
            check   : true,
          },{
            label   : "服务器IP[ServerPublicIpaddr]",
            keys    : "server_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "AUTH服务器 IP[DispSrvIpaddr]",
            keys    : "auth_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "WEB服务器 IP[UmeyeSrvIpaddr]",
            keys    : "web_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          }
        ]
      },
      // 1 -> 001 10 -> 010
      utd_id(){
        var id = this.utd.Form.server_id
        if(this.utd.Form.server_id.length < 2){
          id = "00" + id;
        } else if(this.utd.Form.server_id.length < 3){
          id = "0" + id;
        }
        return id
      },
      utd_txt(){
        return `[NET]
          ServerId=14${this.utd_id}
          ServerPublicIpaddr=${this.utd.Form.server_ip}

          UtdMnTcpListenPort=8550
          UtdTransTcpListenPort=8560

          DispSrvIpaddr=${this.utd.Form.auth_ip}
          DispSrvPort=8250

          SysFlag=hzts
          UmeyeSrvIpaddr=${this.utd.Form.web_ip}
          UmeyeSrvPort=6201

          LogPort=8552

          AgentBeginUdpPort=10000
          AgentEndUdpPort=20000

          LimitMaxNetRate=60
          MonthLimitNetRate=102400000
          MonthTotalNetRate=7382053

          EnableCheckAuth=2

          [TRACE]
          IfShowTraceInfo=0
        `.replaceAll(" ","").split(/\n/)
      },
      utd_highlight(){
        return ["ServerId", "ServerPublicIpaddr", "DispSrvIpaddr", "UmeyeSrvIpaddr"]
      },
    /* MNG */ 
      form_mng(){
        return [
          {
            label   : "服务器IP[PublicSrvIpaddr]",
            keys    : "server_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "WEB服务器 IP[UmeyeSrvIpaddr]",
            keys    : "web_ip",
            type    : "input",
            placeholder: "",
            check   : true,
          },{
            label   : "是/否 开启 Ust[SrvEnable]",
            keys    : "open_ust",
            type    : "radio",
            options : [
              {
                id:0,
                name: "关闭",
              },{
                id:1,
                name: "开启",
              }
            ],
            check   : true,
          },{
            label   : "是/否 开启 Auth[SrvEnable]",
            keys    : "open_auth",
            type    : "radio",
            options : [
              {
                id:0,
                name: "关闭",
              },{
                id:1,
                name: "开启",
              }
            ],
            check   : true,
          },{
            label   : "是/否 开启 Utd[SrvEnable]",
            keys    : "open_utd",
            type    : "radio",
            options : [
              {
                id:0,
                name: "关闭",
              },{
                id:1,
                name: "开启",
              }
            ],
            check   : true,
          },{
            label   : "是/否 开启 Web[SrvEnable]",
            keys    : "open_web",
            type    : "radio",
            options : [
              {
                id:0,
                name: "关闭",
              },{
                id:1,
                name: "开启",
              }
            ],
            check   : true,
          },
        ]
      },
      mng_txt(){
        return `[NET]
          McPort=8130
          PublicSrvIpaddr=${this.mng.Form.server_ip}

          SysFlag=hzts
          UmeyeSrvIpaddr=${this.mng.Form.web_ip}
          UmeyeSrvPort=6003

          [MNSRV]
          MnSrvNum=4

          SrvEnable[0]=${this.mng.Form.open_ust ?"1" :"0"}
          SrvName[0]=NpcSmpUstServer

          SrvEnable[1]=${this.mng.Form.open_auth ?"1" :"0"}
          SrvName[1]=NpcMonAuthServer

          SrvEnable[2]=${this.mng.Form.open_utd ?"1" :"0"}
          SrvName[2]=NpcSmpUtdServer

          SrvEnable[3]=${this.mng.Form.open_web ?"1" :"0"}
          SrvName[3]=UmeyeService

          [SYS]
          LoginUserName=admin
          LoginUserPwd=admin
        `.replaceAll(" ","").split(/\n/)
      },
      mng_highlight(){
        return ["PublicSrvIpaddr","UmeyeSrvIpaddr","SrvEnable"]
      },
  }
}
</script>
<style scoped>
  .main{
    display: flex;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 10px;
    box-shadow: 5px 5px 15px 0px #dddddd;
  }
  .main-box .database /deep/ label {
    color: #00bcd4B0;
  }
  .main-box /deep/ label{
    color: #333;
    font-size: 14px;
    padding-top: 0 !important;
  }
  /*md-theme-default md-has-placeholder*/
  .main-box /deep/ .md-field{
    margin-top: 0 !important;
    /*padding-bottom: 0 !important;*/
  }
  .main-box{
    flex:1;
    max-width: 50%;
    max-height: calc(100vh - 150px);
    padding: 0 10px;
    overflow-y: scroll;
  }
  .type-box{
    padding: 0 15px;
  }
  .putout{
    margin:2px 0;
    line-height: 20px;
    font-size: 12px;
    min-height: 20px;
    line-break: anywhere;
    display: block;
  }
  .putout.highlight{
    background: rgba(255,0,0,0.05);
    color: rgb(255,10,255);
    font-weight: 600;
  }
</style>